var map = {
	".": [
		72812,
		9
	],
	"./": [
		72812,
		9
	],
	"./App": [
		54111,
		9
	],
	"./App.css": [
		44050,
		9
	],
	"./App.js": [
		54111,
		9
	],
	"./App.test": [
		55653,
		9,
		2012,
		6004,
		5653
	],
	"./App.test.js": [
		55653,
		9,
		2012,
		6004,
		5653
	],
	"./ScrollToTop": [
		43279,
		9
	],
	"./ScrollToTop.js": [
		43279,
		9
	],
	"./assets/about1.webp": [
		27990,
		1,
		7990
	],
	"./assets/about2.jpeg": [
		75828,
		1,
		5828
	],
	"./assets/about2.webp": [
		53463,
		1,
		3463
	],
	"./assets/about3.jpeg": [
		29211,
		1,
		9211
	],
	"./assets/arrowRightIcon.png": [
		63976,
		1,
		3976
	],
	"./assets/blank.webp": [
		5364,
		1,
		5364
	],
	"./assets/book-conver.png": [
		1409,
		1,
		1409
	],
	"./assets/book-image-1.png": [
		3125,
		1,
		3125
	],
	"./assets/bookstore-icon.png": [
		41080,
		1,
		1080
	],
	"./assets/collections/biography.png": [
		2719,
		1,
		2719
	],
	"./assets/collections/entrance.avif": [
		51112,
		1,
		1112
	],
	"./assets/collections/fantasy.avif": [
		9452,
		1,
		9452
	],
	"./assets/collections/history.png": [
		59536,
		1,
		9536
	],
	"./assets/collections/maths.png": [
		34193,
		1,
		4193
	],
	"./assets/collections/medical.webp": [
		64367,
		1,
		4367
	],
	"./assets/collections/religious.png": [
		22641,
		1,
		2641
	],
	"./assets/collections/science.png": [
		84634,
		1,
		4634
	],
	"./assets/collections/sports.png": [
		82687,
		1,
		2687
	],
	"./assets/contact-us.png": [
		62977,
		1,
		2977
	],
	"./assets/contact-us.webp": [
		80041,
		1,
		41
	],
	"./assets/expandStore.png": [
		29377,
		1,
		9377
	],
	"./assets/facts.webp": [
		54705,
		1,
		4705
	],
	"./assets/gfb-logo.png": [
		85261,
		1
	],
	"./assets/logo.webp": [
		70781,
		1,
		781
	],
	"./assets/money.avif": [
		68504,
		1,
		8504
	],
	"./assets/money.jpeg": [
		4883,
		1,
		4883
	],
	"./assets/money.png": [
		75938,
		1,
		5938
	],
	"./assets/money.webp": [
		8922,
		1,
		8922
	],
	"./assets/order-books.png": [
		52783,
		1,
		2783
	],
	"./assets/slider-1.jpeg": [
		37554,
		1,
		7554
	],
	"./assets/slider-1.webp": [
		98429,
		1,
		8429
	],
	"./assets/trustedSeller.png": [
		42682,
		1,
		2682
	],
	"./assets/underline.png": [
		44562,
		1,
		4562
	],
	"./assets/white-icon-background.png": [
		96818,
		1,
		6818
	],
	"./components/LayoutComponent": [
		94252,
		9
	],
	"./components/LayoutComponent.js": [
		94252,
		9
	],
	"./components/footer": [
		31728,
		9
	],
	"./components/footer.js": [
		31728,
		9
	],
	"./components/header": [
		58841,
		9
	],
	"./components/header.js": [
		58841,
		9
	],
	"./components/home/Collections": [
		45824,
		9,
		5824
	],
	"./components/home/Collections.js": [
		45824,
		9,
		5824
	],
	"./components/home/OrderBook": [
		69588,
		9,
		1906,
		1346,
		9650,
		9588
	],
	"./components/home/OrderBook.js": [
		69588,
		9,
		1906,
		1346,
		9650,
		9588
	],
	"./components/home/aboutUs": [
		21632,
		9,
		1632
	],
	"./components/home/aboutUs.js": [
		21632,
		9,
		1632
	],
	"./components/home/facts": [
		18490,
		9,
		1906,
		8490
	],
	"./components/home/facts.js": [
		18490,
		9,
		1906,
		8490
	],
	"./hooks/withRouter": [
		77750,
		9,
		7750
	],
	"./hooks/withRouter.js": [
		77750,
		9,
		7750
	],
	"./index": [
		72812,
		9
	],
	"./index.css": [
		59555,
		9
	],
	"./index.js": [
		72812,
		9
	],
	"./lazyImport": [
		64213,
		9
	],
	"./lazyImport.js": [
		64213,
		9
	],
	"./logo.svg": [
		69445,
		1,
		9445
	],
	"./screens/About": [
		90131,
		9,
		1906,
		131,
		8329
	],
	"./screens/About.js": [
		90131,
		9,
		1906,
		131,
		8329
	],
	"./screens/Contact": [
		85571,
		9,
		1906,
		1346,
		5571
	],
	"./screens/Contact.js": [
		85571,
		9,
		1906,
		1346,
		5571
	],
	"./screens/Home": [
		45635,
		9,
		1906,
		1346,
		9650,
		5635,
		5185
	],
	"./screens/Home.js": [
		45635,
		9,
		1906,
		1346,
		9650,
		5635,
		5185
	],
	"./setupTests": [
		89472,
		9,
		2012,
		1405,
		9472
	],
	"./setupTests.js": [
		89472,
		9,
		2012,
		1405,
		9472
	],
	"./styles/about.scss": [
		42350,
		9,
		2350
	],
	"./styles/about/foundingPillers.scss": [
		74904,
		9,
		4904
	],
	"./styles/about/genNext.scss": [
		1942,
		9,
		1942
	],
	"./styles/blogs.scss": [
		59182,
		9,
		9182
	],
	"./styles/clients.scss": [
		15475,
		9,
		5475
	],
	"./styles/contact.scss": [
		80051,
		9,
		51
	],
	"./styles/footer.scss": [
		64062,
		9
	],
	"./styles/gallery.scss": [
		38489,
		9,
		8489
	],
	"./styles/header.scss": [
		22436,
		9
	],
	"./styles/home/aboutUs.scss": [
		51168,
		9,
		1168
	],
	"./styles/home/advancedSecurity.scss": [
		27427,
		9,
		7427
	],
	"./styles/home/collections.scss": [
		19192,
		9,
		9192
	],
	"./styles/home/culture.scss": [
		7375,
		9,
		7375
	],
	"./styles/home/facts.scss": [
		18610,
		9,
		8610
	],
	"./styles/home/feedBack.scss": [
		57500,
		9,
		7500
	],
	"./styles/home/home.scss": [
		46056,
		9,
		6056
	],
	"./styles/home/industryBytes.scss": [
		73644,
		9,
		3644
	],
	"./styles/home/orderBook.scss": [
		36476,
		9,
		6476
	],
	"./styles/home/ourClients.scss": [
		80205,
		9,
		205
	],
	"./styles/home/ourPartners.scss": [
		87636,
		9,
		7636
	],
	"./styles/home/ourServices.scss": [
		70815,
		9,
		815
	],
	"./styles/home/whatWeOffer.scss": [
		83061,
		9,
		3061
	],
	"./styles/layout.scss": [
		37623,
		9
	],
	"./styles/serviceDetail.scss": [
		1225,
		9,
		1225
	],
	"./styles/serviceItems.scss": [
		31068,
		9,
		1068
	],
	"./styles/services.scss": [
		32009,
		9,
		2009
	],
	"./styles/variable.scss": [
		69865,
		9,
		9865
	],
	"./utils/loadSMTP": [
		10444,
		9,
		444
	],
	"./utils/loadSMTP.js": [
		10444,
		9,
		444
	],
	"./utils/menu": [
		9847,
		9
	],
	"./utils/menu.js": [
		9847,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 28969;
module.exports = webpackAsyncContext;